export async function readImageFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const base64Data = event.target.result.split(',')[1]; // Extract the Base64 data
            const jsonData = {
                image: {
                    contentType: file.type,
                    content: base64Data,
                },
            };
            resolve(jsonData);
        };

        reader.onerror = () => {
            reject(new Error('Error reading the file.'));
        };

        reader.readAsDataURL(file);
    });
}